import { render } from "./MarketSolutions.vue?vue&type=template&id=ceba74a4&scoped=true&ts=true"
import script from "./MarketSolutions.vue?vue&type=script&lang=ts"
export * from "./MarketSolutions.vue?vue&type=script&lang=ts"

import "./MarketSolutions.vue?vue&type=style&index=0&id=ceba74a4&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceba74a4"]])

export default __exports__